/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import { getReasonsOfFailure } from '../../../AppUtil/AppUtil';
import UserService from '../../../Service/UserService';
import { withRouter } from 'react-router-dom';
import {
	toastKbaInitaitedPleaseRetuenAfterSomethime,
	toastWaitForFurtherStep,
	toastWhenDocumentIsRejected,
	toastWhenDocumentIsSubmitted
} from '../../../SweetAlertUtil/util';
import Plaid from '../../Common/DwollaPlaid/Plaid';
import { hot } from 'react-hot-loader';
import Loader from '../../Common/Loader';
import DwollaSignUpForm from './Form';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isMainLoading: false
		};
	}

	updateProfile = async () => {
		this.setState({ _isMainLoading: true });
		try {
			const currentUser = await UserService.updateCurrentUser();

			if (currentUser && currentUser.profile) {
				await this.props.setCurrentUser(currentUser);
			}
			this.setState({ _isMainLoading: false });
		} catch (error) {
			this.setState({ _isMainLoading: false });
			console.log(error.message);
		}
	};

	listenToEvent = e => {
		e.returnValue = '';
	};

	componentDidMount() {
		this.updateProfile();
		window.addEventListener('beforeunload', this.listenToEvent);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.listenToEvent);
	}

	// Wallet Creation Code

	checkDocumentUploadedStatus = () => {
		const currentUser = this.props.currentUser.profile;
		if (currentUser.account.documents.length !== 0 && currentUser.account.documents[0].status === 'pending') {
			return 'pending';
		} else {
			return '';
		}
	};

	getReasonsOfFailure = () => {
		return getReasonsOfFailure(this.props.currentUser.profile.account.documents[0].all_failure_reason);
	};

	checkDwollaStatus = () => {
		const currentUser = this.props.currentUser.profile;
		if (currentUser.account !== null) {
			if (currentUser.account.verification_status === 'document') {
				return this.checkDocumentUploadedStatus();
			} else if (
				currentUser.account.verification_status === 'suspended' &&
				currentUser.account.documents[0].failure_reason !== null
			) {
				return 'reviewed_with_failure';
			}
		}
	};

	toastWhenDocumentIsSubmitted = async () => {
		toastWhenDocumentIsSubmitted(this.props.openScreen);
		await this.props.onBack();
	};

	toastWhenDocumentIsRejected = async () => {
		toastWhenDocumentIsRejected(this.getReasonsOfFailure());
		await this.props.onBack();
	};

	toastWaitForFurtherStep = async () => {
		toastWaitForFurtherStep();
		await this.props.onBack();
	};

	toastKbaInitaitedPleaseRetuenAfterSomethime = async () => {
		toastKbaInitaitedPleaseRetuenAfterSomethime();
		await this.props.onBack();
	};
	// End of Wallet Creation

	render() {
		if (this.state._isMainLoading) {
			return <Loader />;
		}

		const queryParams = new URLSearchParams(this.props.location.search);
		const action = queryParams.get('action');
		if (action === 'edit_profile') {
			window.location.href = '/profile';
		}

		return (
			<DwollaSignUpForm
				forKYC={this.props.forKYC}
				currentUser={this.props.currentUser}
				onBack={this.props.onBack}
				openScreen={this.props.openScreen}
				setCurrentUser={this.props.setCurrentUser}
				supportedStates={this.props.supportedStates}
				typeOfUser={this.props.typeOfUser}
			/>
		);

		// const account = this.props.currentUser.profile.account || {};
		// if (!account.customer_id || account.verification_status !== 'verified') {
		// 	const isNoneStepRequired = account.verification && account.verification.stepRequired === 'none';
		// 	if (this.checkDwollaStatus() === 'pending') {
		// 		this.toastWhenDocumentIsSubmitted();
		// 		return null;
		// 	} else if (this.checkDwollaStatus() === 'reviewed_with_failure') {
		// 		this.toastWhenDocumentIsRejected();
		// 		return null;
		// 	} else if (isNoneStepRequired) {
		// 		this.toastWaitForFurtherStep();
		// 		return null;
		// 	} else {
		// 		return (
		// 			<DwollaSignUpForm
		// 				forKYC={this.props.forKYC}
		// 				currentUser={this.props.currentUser}
		// 				onBack={this.props.onBack}
		// 				openScreen={this.props.openScreen}
		// 				setCurrentUser={this.props.setCurrentUser}
		// 				supportedStates={this.props.supportedStates}
		// 				typeOfUser={this.props.typeOfUser}
		// 			/>
		// 		);
		// 	}
		// } else if (!account.funding_source_id || account.plaid_status === 'ITEM_LOGIN_REQUIRED') {
		// 	return (
		// 		<Plaid
		// 			onClose={this.props.onClose}
		// 			openScreen={this.props.openScreen}
		// 			setCurrentUser={this.props.setCurrentUser}
		// 		/>
		// 	);
		// } else {
		// 	return null;
		// }
	}
}

export default withRouter(hot(module)(index));
